export const BRIEF_STATUS = {
  created: 'created',
  submitted: 'submitted',
  done: 'done',
  doneWithErrors: 'done_with_errors',
};
